import React from 'react';

import ExpertTeaser from './Teaser';
import ExpertDetail from './Detail';

const NodeExpert = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <ExpertTeaser {...props} />;
  }

  return <ExpertDetail {...props} />;
};

export default NodeExpert;
